var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"button-element"},[_c('button',{class:['m-button', _vm.type, _vm.borderClassStyle],attrs:{"id":_vm.id,"disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }